import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetChartBar: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 20V10h4v10m2 0V6h4v14m2 0V13h4v7" />
      </svg>
    </div>
  );
};

export default WidgetChartBar;
